import { Component, Input, OnInit} from "@angular/core";
import { BasePage } from "src/app/pages/base-page/base-page";
import { Faq } from "../../models/faq";

@Component({
    selector: 'app-faq-detail',
    templateUrl: './faq-detail.component.html',
    styleUrls: ['./faq-detail.component.scss'],
    standalone: false
})
export class FaqDetailComponent extends BasePage implements OnInit {
  @Input() faq: Faq;
  @Input() index: number;

  tinymceConfig = {
    base_url: '/tinymce',
    suffix: '.min',
    menubar: false,
    toolbar: false,
    statusbar: false,
    readonly: true,
    content_style: 'body { font-size: 1.3em; }',
  };

  constructor(
  ) {
    super();
  }

}
